export default "__VITE_ASSET__CwJkIrS9__"